<script>
export default {
  name: 'TwTextarea',
  props: {
    modelValue: {
      type: [String,Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    smallLabel: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(7)
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 4
    }
  },
  emits: ['update:modelValue']
}
</script>

<template>
  <div class="w-full">
    <label v-if="label" :for="id" class="form-label"> {{ label }} </label>
    <div v-if="smallLabel || $slots.smallLabel" class="form-label-sm">
      <slot name="smallLabel">
        {{ smallLabel }}
      </slot>
    </div>
    <textarea :id="id" :disabled="disabled" :rows="rows" :value="modelValue" :required="required" type="text" :name="id" :autocomplete="id" class="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400 placeholder:text-gray-400 focus:ring-1 focus:ring-inset text-sm focus:ring-gray-800  sm:leading-6" :placeholder="placeholder" @input="$emit('update:modelValue', $event.target.value)" />
    <slot name="under" class="text-sm text-gray-500 mt-1" />
  </div>
</template>

<style scoped>

</style>
